import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'

import WarehouseActions from '../../Redux/WarehouseRedux'
import CreateWarehouse from '../../Containers/Ecommerce/CreateWarehouse'
import UpdateWarehouse from '../../Containers/Ecommerce/UpdateWarehouse'

class ManageWarehouse extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.state = {
      showModal: null,
      detail: {},
      page: 1
    }
  }

  _fetchWarehouse = (event) => {
    if (event) { event.preventDefault() }
    let filter = ''
    this.props.getWarehouse(filter)
  }

  _changePage = (page) => {
    this.setState({ page })
    setTimeout(() => { this._fetchWarehouse() }, 250)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchWarehouse()
    }
  }

  _deleteWarehouse = () => {
    this.props.deleteWarehouse(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  componentDidMount = () => {
    this._fetchWarehouse()
  }

  render () {
    const { warehouse } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Manage Warehouse
              {
                (warehouse.fetching || warehouse.processing) &&
                <div className='badge badge-info ml-2'>{ warehouse.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button
              className='btn btn-primary'
              onClick={() => this._toggleModal('create-warehouse')}
            >
              Create Warehouse
            </button>
          </div>
        </header>

        <section className='section'>
          <div className='card'>
            {
              !(warehouse.fetching || warehouse.processing) && warehouse.err &&
              <div className='alert alert-danger'>{warehouse.err}</div>
            }
            <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
              <thead>
                <tr>
                  <th className='text-center' style={{ minWidth: '200px' }}>Name</th>
                  <th className='text-center' style={{ minWidth: '200px' }}>Address</th>
                  <th className='text-center' style={{ minWidth: '200px' }}>Details</th>
                  <th className='text-center'>Edit</th>
                  <th className='text-center'>Delete</th>
                </tr>
              </thead>
              <tbody>
                {!warehouse.data || !warehouse.data.length
                  ? <tr>
                    <td colSpan='6' className='text-center'>No data</td>
                  </tr>
                  : warehouse.data.map((item, i) => (
                    <tr key={i}>
                      <td className='text-center'>{ item.name }</td>
                      <td className='text-center'>{ item.address }</td>
                      <td className='text-center'>{ item.detail_info }</td>
                      <td className='text-center'>
                        <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-warehouse')} >
                          <i className='fa fa-edit' />Edit
                        </button>
                      </td>
                      <td className='text-center'>
                        <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-warehouse')} >
                          <i className='fa fa-trash' />Delete
                        </button>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </section>
        <section>
          {
            (warehouse.data && warehouse.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={warehouse.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={warehouse.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        {/* Modal for create warehouse */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-warehouse'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateWarehouse closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Modal for edit warehouse */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-warehouse'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateWarehouse detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Modal for delete warehouse */}
        <Modal open={this.state.showModal === 'delete-warehouse'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h3>Delete Warehouse</h3>
            </div>
            <div className='text-center'>
              <h4>
                Confirm deletion
              </h4>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteWarehouse()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  warehouse: state.warehouse
})

const dispatchToProps = (dispatch) => ({
  getWarehouse: (filter) => dispatch(WarehouseActions.getWarehouseRequest(filter)),
  deleteWarehouse: (id) => dispatch(WarehouseActions.deleteWarehouseRequest(id))
})

export default connect(stateToProps, dispatchToProps)(ManageWarehouse)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageWarehouse.js